// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1h6Iu","label":"SetPasswdForm_label__2UuNW"};